import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FunnelSettingsProvider } from "src/app/providers/funnel-settings";
import { UrlsProvider } from "src/app/providers/urls";
import { CDN_IMAGES, LINK_PAGES, ADDRESS, FOOTER_DISCLAIMER } from 'src/constants/param-constants';

export interface FooterLink {
  label: string;
  url: string;
  target?: string;
  show?: boolean;
}

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: "footer-common",
  styleUrls: ['./footer-common.scss'],
  templateUrl: "./footer-common.html"
})
export class FooterCommonComponent {
  public brandLogo: string = CDN_IMAGES.BRAND_LOGO_TRANSPARENT;
  @Input() address: string = ADDRESS;
  @Input() disclaimer: string = FOOTER_DISCLAIMER;

  /**
   * @apiDescription Array of footer links to display
   * @apiParamExample {footerLinks} Example input Array
   *  [{
   *    label: 'Privacy Policy',
   *    url: 'https://drivenentrepreneur.com/privacy/',
   *    target: '_blank',
   *    show: true
   *  }]
   */
  @Input() footerLinks: FooterLink[] = [
    {
      label: 'Privacy Policy',
      url: LINK_PAGES.PRIVACY_POLICY,
      target: '_blank',
      show: true
    },
    {
      label: 'Terms & Conditions',
      url: LINK_PAGES.TERMS_AND_CONDITIONS,
      target: '_blank',
      show: true
    },
    {
      label: 'Your Privacy Choices',
      url: LINK_PAGES.YOUR_PRIVACY_CHOICES,
      target: '_blank',
      show: true
    },
    {
      label: 'CA Privacy Notice',
      url: LINK_PAGES.CA_PRIVACY_NOTICE,
      target: '_blank',
      show: true
    }
  ];

  window: any = window;
  currentYear: number = new Date().getFullYear();

  constructor(
    public funnelProvider: FunnelSettingsProvider,
    public urls: UrlsProvider
  ) {}

  get visibleLinks(): FooterLink[] {
    return this.footerLinks.filter(link => link.show !== false);
  }

  public getSearch() {
    return window.location.search;
  }

  public navigateToPageByGenericUrl(url: string, linkTarget: string, linkOptions: string): void {
    if(url.startsWith("http")) {
      window.open(url, linkTarget, linkOptions);
    } else {
      const currentSessionId = this.funnelProvider.getSessionId();
      const pathName = url;
      let newQueryParams = this.urls.addParamToQuery(
        `${this.getSearch()}`,
        'sessionid',
        currentSessionId
      );
      const nextUrl = `${window.location.origin}/${
        pathName
      }${newQueryParams}`;
      window.open(nextUrl, linkTarget, linkOptions);
    }
  }

}
